import React from 'react';
import Routes from './routes';

import './App.css';

const App = () => (
  <div className="app-fade-in">
    <Routes />
  </div>
);

export default App;
